module.exports = __webpack_public_path__ + "img/loading.95af6c61.svg";